import React, { Component } from "react";
import { withCookies } from "react-cookie";
import Profile from "./Profile";
import Urgence from "./Urgence";
import Liens from "./Liens";
import Agenda from "./Agenda";
import Location from "./Location";
import moduleConfig from "../moduleConfig";
import tracking from "../utils/tracking";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jsonObj: props.source,
      tracking: props.cookies.get("cookie_consent"),
    };
    this.cookieHandler = this.cookieHandler.bind(this);
  }

  componentWillMount() {
    const { cookies } = this.props;
    this.setState({ tracking: cookies.get("cookie_consent") || false });
  }

  cookieHandler() {
    const { cookies } = this.props;
    cookies.set("cookie_consent", true, { path: "/" });

    tracking.event("cookie", "accepter", "ok");
    this.setState({ tracking: true });
  }

  render() {
    if (this.state.jsonObj) {
      const profileData = this.state.jsonObj.basics;
      const consultData = this.state.jsonObj.consultations;
      const urgenceData = this.state.jsonObj.urgences;
      const lienData = this.state.jsonObj.liens;
      const cookieText = this.state.jsonObj.cookie;
      const moduleOrder = [
        "termin",
        "kontaktdaten",
        "zusammenfassung",
        "danke",
      ];
      let modules = moduleOrder.map((key) => {
        let module = moduleConfig[key];
        module.key = key;
        return module;
      });

      return (
        <div className="container">
          {!this.state.tracking && (
            <cookie>
              <div className="col-md-12">
                <div className="inner">
                  <span>{cookieText}</span>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.cookieHandler}
                  >
                    Accepter
                  </button>
                </div>
              </div>
            </cookie>
          )}
          <div className="row">
            <aside className="col-md-4">
              <div className="inner">
                <Profile profileData={profileData} consultData={consultData} />
              </div>
            </aside>
            <main className="col-md-8">
              <div className="inner">
                <Urgence urgenceData={urgenceData} />
                <Liens lienData={lienData} />
                <Agenda modules={modules} />
              </div>
            </main>
          </div>
        </div>
      );
    } else {
      return <p>Loading...</p>;
    }
  }
}

App.defaultProps = { jsonObj: null };

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/components/App.js